<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post-11_kurdistan-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post-11_kurdistan-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.34020618556701;"
    data-aspect-ratio="0.34"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post-11_kurdistan-xs-img"
      class="g-post-11_kurdistan-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-11_kurdistan-xs.jpg);"
    ></div>
    <div
      id="g-ai0-27"
      class="g-text g-aiAbs g-aiPointText"
      style="top:90.3134%;margin-top:-7px;left:45.5734%;margin-left:-22px;width:44px;"
    >
      <p class="g-pstyle16">15%</p>
    </div>
    <div
      id="g-ai0-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:85.9835%;margin-top:-7px;left:48.7774%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle16">17.5%</p>
    </div>
    <div
      id="g-ai0-25"
      class="g-text g-aiAbs g-aiPointText"
      style="top:84.4886%;margin-top:-13.5px;left:28.5724%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle15">Kurds</p>
      <p class="g-pstyle16">25%</p>
    </div>
    <div
      id="g-ai0-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.9422%;margin-top:-20px;left:3.4718%;width:86px;"
    >
      <p class="g-pstyle13">TURKEY</p>
      <p class="g-pstyle14">85.5 million</p>
      <p class="g-pstyle14">inhabitants</p>
    </div>
    <div
      id="g-ai0-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.9628%;margin-top:-13.5px;left:43.5609%;width:52px;"
    >
      <p class="g-pstyle13">IRAN</p>
      <p class="g-pstyle14">91.5</p>
    </div>
    <div
      id="g-ai0-22"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.8477%;margin-top:-9.6px;left:0.4337%;width:270px;"
    >
      <p class="g-pstyle12">Kurdish population by country</p>
    </div>
    <div
      id="g-ai0-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.9465%;margin-top:-8.1px;left:14.1045%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle11">500km</p>
    </div>
    <div
      id="g-ai0-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.3855%;margin-top:-13.5px;left:43.1086%;width:58px;"
    >
      <p class="g-pstyle13">SYRIA</p>
      <p class="g-pstyle14">21.6</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:20.1029%;margin-top:-4px;left:8.229%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle3">500km</p>
    </div>
    <div
      id="g-ai0-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:91.4474%;margin-top:-7px;left:33.3973%;margin-left:-22.5px;width:45px;"
    >
      <p class="g-pstyle16">27%</p>
    </div>
    <div
      id="g-ai0-30"
      class="g-text g-aiAbs g-aiPointText"
      style="top:97.169%;margin-top:-13.5px;left:13.9574%;width:52px;"
    >
      <p class="g-pstyle13">IRAQ</p>
      <p class="g-pstyle14">46</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:47.2249%;margin-top:-8.1px;left:74.6409%;width:63px;"
    >
      <p class="g-pstyle6">Tehran</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:48.5651%;margin-top:-8.1px;left:7.238%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle5">Syria</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:50.8459%;margin-top:-8.2px;left:83.6734%;margin-left:-38px;width:76px;"
    >
      <p class="g-pstyle7">Iran</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:52.4826%;margin-top:-8.1px;right:68.9912%;width:67px;"
    >
      <p class="g-pstyle8">Bagdad</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:56.1939%;margin-top:-8.1px;left:23.7476%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle5">Iraq</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:57.0702%;margin-top:-15.6px;left:64.9979%;width:125px;"
    >
      <p class="g-pstyle9">Higher population</p>
      <p class="g-pstyle9">density</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:60.8846%;margin-top:-15.6px;left:13.5624%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle5">Saudi</p>
      <p class="g-pstyle5">Arabia</p>
    </div>
    <div
      id="g-ai0-20"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:63.9774%;margin-top:-15.6px;left:64.0708%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle10">The</p>
      <p class="g-pstyle10">Gulf</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:17.4697%;margin-top:-12.5px;left:39.3015%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:15.7172%;margin-top:-6.5px;left:7.8411%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle0">egypt</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:14.377%;margin-top:-6.5px;left:51.6458%;margin-left:-23px;width:46px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:12.5213%;margin-top:-6.5px;left:15.9372%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">Israel</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:12.3279%;margin-top:-6.6px;left:76.4372%;margin-left:-33.5px;width:67px;"
    >
      <p class="g-pstyle2">Iran</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:10.7687%;margin-top:-6.5px;right:77.6422%;width:70px;"
    >
      <p class="g-pstyle1">LEBANON</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:9.5316%;margin-top:-6.5px;left:31.8558%;margin-left:-25.5px;width:51px;"
    >
      <p class="g-pstyle0">Syria</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:4.2739%;margin-top:-6.5px;left:88.2907%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Turk.</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:36.4001%;margin-top:-8.1px;left:16.0951%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle5">TURKEY</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:4.1708%;margin-top:-6.5px;left:18.4908%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle0">TURKEY</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-boxtext g-aiAbs"
      style="top:22.8866%;left:0.4337%;width:86.6667%;"
    >
      <p class="g-pstyle4">
        Areas of <span class="g-cstyle0">significant Kurdish presence</span> across
        a territory historically known as Kurdistan, home to an estimated 30&ndash;40
        million people without a state of their own.
      </p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post-11_kurdistan-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.49651439250996;"
    data-aspect-ratio="0.497"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post-11_kurdistan-sm-img"
      class="g-post-11_kurdistan-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-11_kurdistan-sm.jpg);"
    ></div>
    <div
      id="g-ai1-27"
      class="g-text g-aiAbs g-aiPointText"
      style="top:89.2385%;margin-top:-8.6px;left:53.1344%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle16">15%</p>
    </div>
    <div
      id="g-ai1-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.9813%;margin-top:-8.6px;left:55.7655%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle16">17.5%</p>
    </div>
    <div
      id="g-ai1-25"
      class="g-text g-aiAbs g-aiPointText"
      style="top:82.2289%;margin-top:-16.6px;left:39.0998%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle15">Kurds</p>
      <p class="g-pstyle16">25%</p>
    </div>
    <div
      id="g-ai1-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:74.3431%;margin-top:-24.6px;left:18.3319%;width:96px;"
    >
      <p class="g-pstyle13">TURKEY</p>
      <p class="g-pstyle14">85.5 million</p>
      <p class="g-pstyle14">inhabitants</p>
    </div>
    <div
      id="g-ai1-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.1748%;margin-top:-16.6px;left:51.5121%;width:57px;"
    >
      <p class="g-pstyle13">IRAN</p>
      <p class="g-pstyle14">91.5</p>
    </div>
    <div
      id="g-ai1-22"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.6255%;margin-top:-9.6px;left:0.1961%;width:270px;"
    >
      <p class="g-pstyle12">Kurdish population by country</p>
    </div>
    <div
      id="g-ai1-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.7759%;margin-top:-8.1px;left:9.2934%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle11">500km</p>
    </div>
    <div
      id="g-ai1-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.1063%;margin-top:-16.6px;left:51.1376%;width:63px;"
    >
      <p class="g-pstyle13">SYRIA</p>
      <p class="g-pstyle14">21.6</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.2763%;margin-top:-4px;left:18.8726%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle3">500km</p>
    </div>
    <div
      id="g-ai1-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:90.6988%;margin-top:-8.6px;left:43.1463%;margin-left:-24.5px;width:49px;"
    >
      <p class="g-pstyle16">27%</p>
    </div>
    <div
      id="g-ai1-30"
      class="g-text g-aiAbs g-aiPointText"
      style="top:97.6111%;margin-top:-16.6px;left:27.0104%;width:56px;"
    >
      <p class="g-pstyle13">IRAQ</p>
      <p class="g-pstyle14">46</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:44.2074%;margin-top:-8.1px;left:65.9626%;width:63px;"
    >
      <p class="g-pstyle6">Tehran</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:45.473%;margin-top:-8.1px;left:22.3489%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle5">Syria</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:47.627%;margin-top:-8.2px;left:71.8072%;margin-left:-38px;width:76px;"
    >
      <p class="g-pstyle7">Iran</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:49.1726%;margin-top:-8.1px;right:62.2698%;width:67px;"
    >
      <p class="g-pstyle8">Bagdad</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:52.6774%;margin-top:-8.1px;left:33.0317%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle5">Iraq</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:53.5049%;margin-top:-15.6px;left:59.7231%;width:125px;"
    >
      <p class="g-pstyle9">Higher population</p>
      <p class="g-pstyle9">density</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:57.107%;margin-top:-15.6px;left:26.4412%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle5">Saudi</p>
      <p class="g-pstyle5">Arabia</p>
    </div>
    <div
      id="g-ai1-20"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:60.0277%;margin-top:-15.6px;left:59.1232%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle10">The</p>
      <p class="g-pstyle10">Gulf</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:16.4976%;margin-top:-12.5px;left:42.7037%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:14.8425%;margin-top:-6.5px;left:22.3471%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle0">egypt</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:13.5769%;margin-top:-6.5px;left:50.6913%;margin-left:-23px;width:46px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:11.8245%;margin-top:-6.5px;left:27.5858%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">Israel</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:11.6419%;margin-top:-6.6px;left:66.7327%;margin-left:-33.5px;width:67px;"
    >
      <p class="g-pstyle2">Iran</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:10.1694%;margin-top:-6.5px;right:68.2597%;width:70px;"
    >
      <p class="g-pstyle1">LEBANON</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:9.0012%;margin-top:-6.5px;left:37.886%;margin-left:-25.5px;width:51px;"
    >
      <p class="g-pstyle0">Syria</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:4.036%;margin-top:-6.5px;left:74.4028%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Turk.</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:33.9851%;margin-top:-8.1px;left:28.0801%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle5">TURKEY</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:3.9387%;margin-top:-6.5px;left:29.2381%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle0">TURKEY</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-boxtext g-aiAbs"
      style="top:22.4892%;left:0.1961%;width:91.5686%;"
    >
      <p class="g-pstyle4">
        Areas of <span class="g-cstyle0">significant Kurdish presence</span> across
        a territory historically known as Kurdistan, home to an estimated 30&ndash;40
        million people without a state of their own.
      </p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post-11_kurdistan-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.54518375632649;"
    data-aspect-ratio="0.545"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post-11_kurdistan-md-img"
      class="g-post-11_kurdistan-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-11_kurdistan-md.jpg);"
    ></div>
    <div
      id="g-ai2-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:89.1015%;margin-top:-8.7px;left:52.9053%;margin-left:-24.5px;width:49px;"
    >
      <p class="g-pstyle18">15%</p>
    </div>
    <div
      id="g-ai2-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.8149%;margin-top:-8.7px;left:55.3584%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle18">17.5%</p>
    </div>
    <div
      id="g-ai2-27"
      class="g-text g-aiAbs g-aiPointText"
      style="top:81.9355%;margin-top:-16.9px;left:40.0163%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle17">Kurds</p>
      <p class="g-pstyle18">25%</p>
    </div>
    <div
      id="g-ai2-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.8608%;margin-top:-25.2px;left:20.8878%;width:101px;"
    >
      <p class="g-pstyle15">TURKEY</p>
      <p class="g-pstyle16">85.5 million</p>
      <p class="g-pstyle16">inhabitants</p>
    </div>
    <div
      id="g-ai2-25"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.8929%;margin-top:-19.4px;left:51.39%;width:59px;"
    >
      <p class="g-pstyle13">IRAN</p>
      <p class="g-pstyle14">91.5</p>
    </div>
    <div
      id="g-ai2-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:69.0254%;margin-top:-9.6px;left:19.4694%;width:270px;"
    >
      <p class="g-pstyle12">Kurdish population by country</p>
    </div>
    <div
      id="g-ai2-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.8126%;margin-top:-8.6px;left:10.8949%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle11">500km</p>
    </div>
    <div
      id="g-ai2-31"
      class="g-text g-aiAbs g-aiPointText"
      style="top:93.9956%;margin-top:-16.9px;left:51.0458%;width:66px;"
    >
      <p class="g-pstyle15">SYRIA</p>
      <p class="g-pstyle16">21.6</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.6858%;margin-top:-4px;left:25.7283%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle3">500km</p>
    </div>
    <div
      id="g-ai2-30"
      class="g-text g-aiAbs g-aiPointText"
      style="top:90.5884%;margin-top:-8.7px;left:43.6355%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle18">27%</p>
    </div>
    <div
      id="g-ai2-32"
      class="g-text g-aiAbs g-aiPointText"
      style="top:97.3824%;margin-top:-16.9px;left:28.8659%;width:59px;"
    >
      <p class="g-pstyle15">IRAQ</p>
      <p class="g-pstyle16">46</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:31.1104%;margin-top:-8.6px;left:9.0215%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle5">TURKEY</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:41.3532%;margin-top:-8.6px;left:75.4674%;width:66px;"
    >
      <p class="g-pstyle6">Tehran</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:43.6661%;margin-top:-8.6px;left:19.5811%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle5">Syria</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:45.3732%;margin-top:-10.3px;left:85.0306%;margin-left:-41.5px;width:83px;"
    >
      <p class="g-pstyle7">Iran</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:48.6223%;margin-top:-8.6px;left:42.1983%;width:70px;"
    >
      <p class="g-pstyle8">Bagdad</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:52.2569%;margin-top:-16.6px;left:76.1038%;width:132px;"
    >
      <p class="g-pstyle9">Higher population</p>
      <p class="g-pstyle9">density</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:54.9002%;margin-top:-8.6px;left:47.9332%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle5">Iraq</p>
    </div>
    <div
      id="g-ai2-20"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:55.148%;margin-top:-8.6px;left:12.058%;margin-left:-38.5px;width:77px;"
    >
      <p class="g-pstyle5">JORDAN</p>
    </div>
    <div
      id="g-ai2-21"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:59.113%;margin-top:-16.6px;left:32.5411%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle5">Saudi</p>
      <p class="g-pstyle5">Arabia</p>
    </div>
    <div
      id="g-ai2-22"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:60.3521%;margin-top:-16.6px;left:67.0278%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle10">The</p>
      <p class="g-pstyle10">Gulf</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:14.3281%;margin-top:-12.5px;left:44.1433%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:12.9239%;margin-top:-6.5px;left:28.4131%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle0">egypt</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:11.85%;margin-top:-6.5px;left:50.3155%;margin-left:-23px;width:46px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:10.3632%;margin-top:-6.5px;left:32.4612%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">Israel</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:10.2082%;margin-top:-6.6px;left:62.7111%;margin-left:-33.5px;width:67px;"
    >
      <p class="g-pstyle2">Iran</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:8.9589%;margin-top:-6.5px;right:64.3285%;width:70px;"
    >
      <p class="g-pstyle1">LEBANON</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:7.9677%;margin-top:-6.5px;left:40.4205%;margin-left:-25.5px;width:51px;"
    >
      <p class="g-pstyle0">Syria</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:3.7549%;margin-top:-6.5px;left:68.638%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Turk.</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:28.4671%;margin-top:-8.6px;left:95.0308%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle5">Turk.</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:3.6723%;margin-top:-6.5px;left:33.7379%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle0">TURKEY</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-boxtext g-aiAbs"
      style="top:19.9075%;left:0.6886%;width:99.0909%;"
    >
      <p class="g-pstyle4">
        Areas of <span class="g-cstyle0">significant Kurdish presence</span> across
        a territory historically known as Kurdistan, home to an estimated 30&ndash;40
        million people without a state of their own.
      </p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post-11_kurdistan-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 1.01086956521739;"
    data-aspect-ratio="1.011"
    data-min-width="930"
  >
    <div
      id="g-post-11_kurdistan-lg-img"
      class="g-post-11_kurdistan-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-11_kurdistan-lg.jpg);"
    ></div>
    <div
      id="g-ai3-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.4634%;margin-top:-8.7px;left:45.2634%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle15">27%</p>
    </div>
    <div
      id="g-ai3-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:85.5069%;margin-top:-8.7px;left:51.8419%;margin-left:-24.5px;width:49px;"
    >
      <p class="g-pstyle15">15%</p>
    </div>
    <div
      id="g-ai3-22"
      class="g-text g-aiAbs g-aiPointText"
      style="top:78.5504%;margin-top:-8.7px;left:53.5828%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle15">17.5%</p>
    </div>
    <div
      id="g-ai3-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.0774%;margin-top:-16.9px;left:42.6949%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle14">Kurds</p>
      <p class="g-pstyle15">25%</p>
    </div>
    <div
      id="g-ai3-20"
      class="g-text g-aiAbs g-aiPointText"
      style="top:65.3434%;margin-top:-25.2px;left:29.1198%;width:101px;"
    >
      <p class="g-pstyle12">TURKEY</p>
      <p class="g-pstyle13">85.5 million</p>
      <p class="g-pstyle13">inhabitants</p>
    </div>
    <div
      id="g-ai3-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.0698%;margin-top:-19.4px;left:50.7665%;width:59px;"
    >
      <p class="g-pstyle10">IRAN</p>
      <p class="g-pstyle11">91.5</p>
    </div>
    <div
      id="g-ai3-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.0894%;margin-top:-9.6px;left:28.1132%;width:270px;"
    >
      <p class="g-pstyle9">Kurdish population by country</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.9367%;margin-top:-9.2px;left:7.0435%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle8">500km</p>
    </div>
    <div
      id="g-ai3-25"
      class="g-text g-aiAbs g-aiPointText"
      style="top:91.9469%;margin-top:-16.9px;left:50.5223%;width:66px;"
    >
      <p class="g-pstyle12">SYRIA</p>
      <p class="g-pstyle13">21.6</p>
    </div>
    <div
      id="g-ai3-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.4034%;margin-top:-16.9px;left:34.7817%;width:59px;"
    >
      <p class="g-pstyle12">IRAQ</p>
      <p class="g-pstyle13">46</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:39.0305%;margin-top:-9.1px;left:28.8121%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle1">JORDAN</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:44.3566%;margin-top:-9.1px;left:5.5069%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle1">egypt</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:47.3458%;margin-top:-16.6px;left:65.2273%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle7">The</p>
      <p class="g-pstyle7">Gulf</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:47.3645%;margin-top:-17.8px;left:38.2371%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle1">Saudi</p>
      <p class="g-pstyle1">Arabia</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:36.2678%;margin-top:-15.7px;left:68.9512%;width:140px;"
    >
      <p class="g-pstyle6">Higher population</p>
      <p class="g-pstyle6">density</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:54.2479%;margin-top:-9.1px;right:26.4181%;width:64px;"
    >
      <p class="g-pstyle4">Qatar</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:33.2697%;margin-top:-9.1px;left:21.4084%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle1">Israel</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:31.2135%;margin-top:-9.2px;left:47.9127%;width:73px;"
    >
      <p class="g-pstyle5">Bagdad</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:28.9219%;margin-top:-9.1px;right:74.9641%;width:83px;"
    >
      <p class="g-pstyle4">LEBANON</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:28.5006%;margin-top:-9.2px;left:78.8791%;margin-left:-38px;width:76px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:25.4436%;margin-top:-9.1px;left:33.6247%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle1">Syria</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:22.7352%;margin-top:-9.2px;left:68.9762%;width:69px;"
    >
      <p class="g-pstyle2">Tehran</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:14.574%;margin-top:-9.1px;left:92.2519%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle1">Turk.</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:10.7697%;margin-top:-9.1px;left:26.9359%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle1">TURKEY</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:38.7045%;margin-top:-9.1px;left:51.5542%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle1">Iraq</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-boxtext g-aiAbs"
      style="top:2.3913%;left:54.3277%;width:43.871%;"
    >
      <p class="g-pstyle0">
        Areas of <span class="g-cstyle0">significant Kurdish presence</span> across
        a territory historically known as Kurdistan, home to an estimated 30&ndash;40
        million people without a state of their own.
      </p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-12 17:28 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-12 17:28 -->
<!-- ai file: post-11_kurdistan.ai -->
<style lang="scss">
  #g-post-11_kurdistan-box {
    container-type: inline-size;
    container-name: g-post-11_kurdistan-box;
  }
  #g-post-11_kurdistan-box,
  #g-post-11_kurdistan-box .g-artboard {
    margin: 0 auto;
  }
  #g-post-11_kurdistan-box p {
    margin: 0;
  }
  #g-post-11_kurdistan-box .g-aiAbs {
    position: absolute;
  }
  #g-post-11_kurdistan-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post-11_kurdistan-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post-11_kurdistan-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-11_kurdistan-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-11_kurdistan-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post-11_kurdistan-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post-11_kurdistan-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post-11_kurdistan-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-post-11_kurdistan-lg {
        display: block !important;
      }
    }
  }
  #g-post-11_kurdistan-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-11_kurdistan-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post-11_kurdistan-xs .g-pstyle0 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    font-size: 11px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(173, 173, 173);
  }
  #g-post-11_kurdistan-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    font-size: 11px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(173, 173, 173);
  }
  #g-post-11_kurdistan-xs .g-pstyle2 {
    font-weight: 900;
    line-height: 12px;
    height: 12px;
    letter-spacing: 0.27em;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post-11_kurdistan-xs .g-pstyle3 {
    font-weight: 300;
    line-height: 7px;
    height: 7px;
    font-size: 12px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-xs .g-pstyle4 {
    font-weight: 400;
  }
  #g-post-11_kurdistan-xs .g-pstyle5 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-xs .g-pstyle6 {
    font-weight: 500;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    color: rgb(102, 102, 102);
  }
  #g-post-11_kurdistan-xs .g-pstyle7 {
    font-weight: 900;
    line-height: 15px;
    height: 15px;
    letter-spacing: 0.27em;
    font-size: 17px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post-11_kurdistan-xs .g-pstyle8 {
    font-weight: 300;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post-11_kurdistan-xs .g-pstyle9 {
    font-weight: 400;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    color: rgb(108, 126, 148);
  }
  #g-post-11_kurdistan-xs .g-pstyle10 {
    font-weight: 400;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-xs .g-pstyle11 {
    font-weight: 300;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-xs .g-pstyle12 {
    font-weight: 700;
    height: 18px;
    text-transform: uppercase;
  }
  #g-post-11_kurdistan-xs .g-pstyle13 {
    font-weight: 700;
    line-height: 13px;
    height: 13px;
    font-size: 13px;
  }
  #g-post-11_kurdistan-xs .g-pstyle14 {
    font-weight: 300;
    line-height: 13px;
    height: 13px;
    font-size: 13px;
  }
  #g-post-11_kurdistan-xs .g-pstyle15 {
    font-weight: 700;
    line-height: 13px;
    height: 13px;
    font-size: 13px;
    text-align: center;
  }
  #g-post-11_kurdistan-xs .g-pstyle16 {
    font-weight: 300;
    line-height: 13px;
    height: 13px;
    font-size: 13px;
    text-align: center;
  }
  #g-post-11_kurdistan-xs .g-cstyle0 {
    font-weight: 700;
  }
  #g-post-11_kurdistan-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-11_kurdistan-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post-11_kurdistan-sm .g-pstyle0 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    font-size: 11px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(173, 173, 173);
  }
  #g-post-11_kurdistan-sm .g-pstyle1 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    font-size: 11px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(173, 173, 173);
  }
  #g-post-11_kurdistan-sm .g-pstyle2 {
    font-weight: 900;
    line-height: 12px;
    height: 12px;
    letter-spacing: 0.27em;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post-11_kurdistan-sm .g-pstyle3 {
    font-weight: 300;
    line-height: 7px;
    height: 7px;
    font-size: 12px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-sm .g-pstyle4 {
    font-weight: 400;
  }
  #g-post-11_kurdistan-sm .g-pstyle5 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-sm .g-pstyle6 {
    font-weight: 500;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    color: rgb(102, 102, 102);
  }
  #g-post-11_kurdistan-sm .g-pstyle7 {
    font-weight: 900;
    line-height: 15px;
    height: 15px;
    letter-spacing: 0.27em;
    font-size: 17px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post-11_kurdistan-sm .g-pstyle8 {
    font-weight: 300;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post-11_kurdistan-sm .g-pstyle9 {
    font-weight: 400;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    color: rgb(108, 126, 148);
  }
  #g-post-11_kurdistan-sm .g-pstyle10 {
    font-weight: 400;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-sm .g-pstyle11 {
    font-weight: 300;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-sm .g-pstyle12 {
    font-weight: 700;
    height: 18px;
    text-transform: uppercase;
  }
  #g-post-11_kurdistan-sm .g-pstyle13 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
  }
  #g-post-11_kurdistan-sm .g-pstyle14 {
    font-weight: 300;
    line-height: 16px;
    height: 16px;
  }
  #g-post-11_kurdistan-sm .g-pstyle15 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    text-align: center;
  }
  #g-post-11_kurdistan-sm .g-pstyle16 {
    font-weight: 300;
    line-height: 16px;
    height: 16px;
    text-align: center;
  }
  #g-post-11_kurdistan-sm .g-cstyle0 {
    font-weight: 700;
  }
  #g-post-11_kurdistan-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-11_kurdistan-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post-11_kurdistan-md .g-pstyle0 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    font-size: 11px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(173, 173, 173);
  }
  #g-post-11_kurdistan-md .g-pstyle1 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    font-size: 11px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(173, 173, 173);
  }
  #g-post-11_kurdistan-md .g-pstyle2 {
    font-weight: 900;
    line-height: 12px;
    height: 12px;
    letter-spacing: 0.27em;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post-11_kurdistan-md .g-pstyle3 {
    font-weight: 300;
    line-height: 7px;
    height: 7px;
    font-size: 12px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-md .g-pstyle4 {
    font-weight: 400;
  }
  #g-post-11_kurdistan-md .g-pstyle5 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 15px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-md .g-pstyle6 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 15px;
    color: rgb(102, 102, 102);
  }
  #g-post-11_kurdistan-md .g-pstyle7 {
    font-weight: 900;
    height: 19px;
    letter-spacing: 0.27em;
    font-size: 19px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post-11_kurdistan-md .g-pstyle8 {
    font-weight: 300;
    line-height: 16px;
    height: 16px;
    font-size: 15px;
    color: rgb(102, 102, 102);
  }
  #g-post-11_kurdistan-md .g-pstyle9 {
    font-weight: 400;
    font-style: italic;
    line-height: 16px;
    height: 16px;
    font-size: 15px;
    color: rgb(108, 126, 148);
  }
  #g-post-11_kurdistan-md .g-pstyle10 {
    font-weight: 400;
    font-style: italic;
    line-height: 16px;
    height: 16px;
    font-size: 15px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-md .g-pstyle11 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 15px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-md .g-pstyle12 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-transform: uppercase;
  }
  #g-post-11_kurdistan-md .g-pstyle13 {
    font-weight: 700;
    height: 19px;
  }
  #g-post-11_kurdistan-md .g-pstyle14 {
    font-weight: 300;
    height: 19px;
  }
  #g-post-11_kurdistan-md .g-pstyle15 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
  }
  #g-post-11_kurdistan-md .g-pstyle16 {
    font-weight: 300;
    line-height: 16px;
    height: 16px;
  }
  #g-post-11_kurdistan-md .g-pstyle17 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    text-align: center;
  }
  #g-post-11_kurdistan-md .g-pstyle18 {
    font-weight: 300;
    line-height: 16px;
    height: 16px;
    text-align: center;
  }
  #g-post-11_kurdistan-md .g-cstyle0 {
    font-weight: 700;
  }
  #g-post-11_kurdistan-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-11_kurdistan-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post-11_kurdistan-lg .g-pstyle0 {
    font-weight: 400;
  }
  #g-post-11_kurdistan-lg .g-pstyle1 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-lg .g-pstyle2 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    color: rgb(102, 102, 102);
  }
  #g-post-11_kurdistan-lg .g-pstyle3 {
    font-weight: 900;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0.27em;
    font-size: 17px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post-11_kurdistan-lg .g-pstyle4 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-lg .g-pstyle5 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    color: rgb(102, 102, 102);
  }
  #g-post-11_kurdistan-lg .g-pstyle6 {
    font-weight: 400;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    color: rgb(108, 126, 148);
  }
  #g-post-11_kurdistan-lg .g-pstyle7 {
    font-weight: 400;
    font-style: italic;
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-lg .g-pstyle8 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 15px;
    text-align: center;
    color: rgb(153, 153, 153);
  }
  #g-post-11_kurdistan-lg .g-pstyle9 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-transform: uppercase;
  }
  #g-post-11_kurdistan-lg .g-pstyle10 {
    font-weight: 700;
    height: 19px;
  }
  #g-post-11_kurdistan-lg .g-pstyle11 {
    font-weight: 300;
    height: 19px;
  }
  #g-post-11_kurdistan-lg .g-pstyle12 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
  }
  #g-post-11_kurdistan-lg .g-pstyle13 {
    font-weight: 300;
    line-height: 16px;
    height: 16px;
  }
  #g-post-11_kurdistan-lg .g-pstyle14 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    text-align: center;
  }
  #g-post-11_kurdistan-lg .g-pstyle15 {
    font-weight: 300;
    line-height: 16px;
    height: 16px;
    text-align: center;
  }
  #g-post-11_kurdistan-lg .g-cstyle0 {
    font-weight: 700;
  }

  /* Custom CSS */
  @mixin shadow-emmental($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 1);
    text-shadow:
      -1px 0 rgba($clr, $alpha),
      0 1px rgba($clr, $alpha),
      1px 0 rgba($clr, $alpha),
      0 -1px rgba($clr, $alpha);
  }
  .g-boxtext {
    background-color: #ffffffb3;
    padding: 7px 10px;
  }
  .g-whiteshadow {
    @include shadow-emmental(#ffffff);
  }
</style>
